import React from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import { Col, Row } from 'react-bootstrap';
import scorecards from 'assets/img/spot-illustrations/scorecards.png';
import ScorecardList from './ScorecardList';

const ScorecardManagement: React.FC = () => {
  return (
    <div>
      <h2 className="mb-4 lh-sm">Scorecard Management</h2>
      <PhoenixDocCard className="mb-4">
        <PhoenixDocCard.Header noPreview className="pb-2 pt-3">
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-2">Scorecards for evaluating call quality</h4>
                <p className="mb-0">
                  Scorecards are essential tools for assessing the quality of
                  calls in your campaigns. They consist of a set of questions
                  with associated weights and values, allowing for a
                  standardized evaluation process across different campaigns.
                  <br />
                  <br />
                  Manage your scorecards here, including creating new ones,
                  modifying existing ones, and assigning them to campaigns.
                  Remember, once a scorecard has been used, only certain fields
                  can be modified to maintain data integrity.
                </p>
              </div>
            </Col>
            <Col xs="auto" className="order-xxl-2">
              <div className="x-6">
                <img src={scorecards} alt="" />
              </div>
            </Col>
          </Row>
        </PhoenixDocCard.Header>
        <PhoenixDocCard.Body>
          <div className="px-4">
            <ScorecardList />
          </div>
        </PhoenixDocCard.Body>
      </PhoenixDocCard>
    </div>
  );
};

export default ScorecardManagement;
